import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row } from 'reactstrap';
import { AddFileAttempt_ACTION, AddObjectAttempt_ACTION, GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';
import { CheckKeyboardAnswer, CreateChuck, responsiveFontSize, responsiveHeight, responsiveWidth, SafeSimplify } from '../Services/Utilities';
import LatexViewComponent from './LatexViewComponent';
import SafeLatexViewComponent from './SafeLatexViewComponent';
import LatexViewComponent2 from './LatexViewComponent2';
import RenderLatexAnswer from './RenderLatexAnswer';
import KeyboardComponent from './KeyboardComponent';

const NUMERIC_BLOCK = +8
const VARIABLE_BLOCK = +9

var typingTimer

class KeyboardQuestionPlayComponent extends Component {
    constructor(props){
        super(props)
        this.first_line_ref = React.createRef()

        this.state = {
            Answer:{
                List:[],
                echoNumber:0
            },
            Right:false,
            Left:false,
            RightBracket: true,
            LeftBracket: false,
            ShowVarModal:false,
    
            SelectedVariableKey:{
                VImages:[]
            },
            CheckAnswer: false, 
            ShowSolution: false,
            StartTime:0,
            FirstLineWidth: responsiveWidth(60),
            componentVisible:false,
            InputError: ""
        }

        this.TopPart = this.TopPart.bind(this)
        this.ActionLine = this.ActionLine.bind(this)
        this.AnswerStatusSolutionSection = this.AnswerStatusSolutionSection.bind(this)
        //
        this.NextAction = this.NextAction.bind(this)
        this.ClearAction = this.ClearAction.bind(this)
        this.CheckAnswerAction = this.CheckAnswerAction.bind(this)
        this.VerifyAnswer = this.VerifyAnswer.bind(this)
    }

    componentDidMount(){
        this.setState({
            Id: this.props.Id
        })
        
        this.props.GetInfo(this.props.Id)
        typingTimer = setTimeout(() => {
            this.setState({
                FirstLineWidth:this.first_line_ref.current.offsetWidth,
                componentVisible: true
                })
        }, 100);
    }

    componentWillReceiveProps(nextprops){
        if(nextprops.InSeries && nextprops.Question && nextprops.Id == this.state.Id){

            this.props.Object.setState(prev => ({
                LoadedClickableQuestions:  [...prev.LoadedClickableQuestions, nextprops.Question]
            }))
            
        }

        if(nextprops.Id != this.state.Id){
            this.props.GetInfo(nextprops.Id)

            this.setState({
                Id: nextprops.Id,
                Answer:{
                    List:[],
                    echoNumber:0
                },
                Right:false,
                Left:false,
                RightBracket: true,
                LeftBracket: false,
                ShowVarModal:false,
        
                SelectedVariableKey:{
                    VImages:[]
                },
                CheckAnswer: false,
                ShowSolution: false,
                StartTime: (new Date()).getTime()

            })
        }
    }

    render(){
        let ShowSolutions = true 
        if(this.props.Map){
            ShowSolutions = this.props.Map.ShowSolutions
        }

        let FirstLineWidth = this.state.FirstLineWidth

        console.log(this)
        return(
            <div
            ref = {this.first_line_ref}

            >
              {(this.props.IsQuestionSearching  || this.props.IsQuestionSearching == undefined || this.props.GetQuestionError || this.props.GetQuestionError == undefined) ? 
                      <SearchingTitleComponent error = {this.props.GetQuestionError}/>
                  : <div>
                        {this.TopPart()}
                        {this.ActionLine(ShowSolutions)}
                        
                        
                        {!this.state.CheckAnswer ? 
                        
                        <KeyboardComponent 
                            Father = {this}
                            keyboard = {this.props.Question.Keyboard}
                            answer_line = {this.state.Answer}
                            disable_devision = {this.props.Question.DisableDevision}
                            energy_balance = {this.props.Question.IsEnergyBalance}

                        /> : (this.AnswerStatusSolutionSection(ShowSolutions))}   
                    </div>}
            </div>
        )
    }

    TopPart(){
        let FirstLineWidth = this.state.FirstLineWidth

        return(
            <div
            style = {{flexDirection:'row', display:'flex', alignItems:'flex-start', alignContent:'space-between'}}>
                <div style = {{
                    flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center',
                    width:FirstLineWidth*0.23, marginLeft:0.01*FirstLineWidth, marginRight:0.01*FirstLineWidth, }}>
                        <img 
                        src = {this.props.Question.ImageURL}
                        style = {{width: FirstLineWidth*0.22,
                             height:FirstLineWidth*0.22,
                              objectFit:'contain'}}
                    />
                    
                </div>
                <div style = {{
                    flexDirection:'column', display:'flex', alignContent:'center', alignItems:'center',
                    width:FirstLineWidth*0.75,  }}
                    >
                        <div style = {{height:FirstLineWidth*0.15, width:'100%', flexDirection:'row', display:'flex', overflowY:'scroll' }}>
                            <SafeLatexViewComponent
                            source={this.props.Question.Latex}
                            />

                        </div>
                        <div style = {{height:FirstLineWidth*0.025, width:'100%', flexDirection:'row', display:'flex' }}>
                            <h5 style = {{color:'#008fb3', fontSize: responsiveFontSize(0.7)}}>
                            {this.props.Question.AdditionalInfo}
                                </h5>

                        </div>
                        
                        <div style = {{width:'99%', flexDirection:'row', display:'flex', alignContent:'flex-start', alignItems:'flex-start', borderBottom:1, borderBottomColor:this.state.KeyboardIn  ? 'green' : '#cccccc', borderBottomStyle:'solid',
                         height:FirstLineWidth*0.05, overflowX:'scroll' }}>
                            <LatexViewComponent2 
                                        text = {'\\large{' + this.state.Answer.List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '') + '}'}
                                        NoBorder
                                    />
                        </div>
                        <div style = {{width:'99%', flexDirection:'row', display:'flex', alignContent:'flex-start', alignItems:'flex-start' }}>
                            <h6
                            className="text text-danger"
                            style={{fontSize: responsiveFontSize(0.75)}}
                            >{this.state.InputError}</h6>
                        </div>
                    
                </div>
            </div>
        )
    }

    ActionLine(ShowSolutions){
        let FirstLineWidth = this.state.FirstLineWidth
        
        return(
            <div style = {{flexDirection:'row', display:'flex', marginTop: responsiveHeight(2)}}>
                <div style = {{width: FirstLineWidth*0.25}} />
                <div style = {{width: FirstLineWidth*0.75, flexDirection:'row', display:'flex'}}>
                {this.state.CheckAnswer && this.props.InSeries &&this.props.Object? 
                    <div
                    className ="square border border-primary"
                     style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                         flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                        onClick = {() => this.NextAction()}
                        >
                           <h5 style = {{color: '#0099cc', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                   Next
                                </h5>
                    </div>  :<div/>}

                {!this.state.CheckAnswer ? 
                    <div
                            className ="square border border-danger"
                             style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                                 flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                                onClick = {() => this.ClearAction()}
                                >
                                   <h5 style = {{color: 'red', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                            Clear
                                        </h5>
                            </div>: <div/>}


                {!this.state.CheckAnswer ? 
                   <div
                   className ="square border border-primary"
                    style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                        flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                       onClick = {() => this.CheckAnswerAction()}
                       >
                          <h5 style = {{color: '#0099cc', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                   Check answer
                               </h5>
                   </div> : <div/>}


                {this.state.CheckAnswer  && this.props.Question.PDFURL  && ShowSolutions? 
                   <div
                   className ="square border border-danger"
                    style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                        flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                       onClick = {() => {
                        window.open(this.props.Question.PDFURL)  

                        let data = new FormData()

                        data.append('QuestionId',this.props.Question.Id)
                        data.append('Player', this.props.Player)
                        data.append('Correct', this.state.AnswerStatus)

                        this.props.PostPDFStatistic(data)
                       }}
                       >
                          <h5 style = {{color: 'red', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                                   PDF
                               </h5>
                   </div>
                    : <div/>}

                {this.state.CheckAnswer  && this.props.Question.VIDEOURL  && ShowSolutions? 
                   
                    <div
                    className ="square border border-primary"
                     style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                         flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}
 
                        onClick = {() =>{
                            window.open(this.props.Question.VIDEOURL)  
                        }}
                        >
                           <h5 style = {{color: '#0099cc', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                           Video
                            </h5>
                    </div>
                    : <div/>}

                {!this.state.CheckAnswer? 
                   <div
                   className ="square border border-success"
                    style = {{margin: responsiveFontSize(0.5), borderRadius: responsiveFontSize(0.2),
                        flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center',cursor:'pointer'}}

                       onClick = {() =>{
                        this.props.GetInfo(this.props.Question.Id)

                        this.setState({
                                            Id: this.props.Question.Id,
                                            Answer:{
                                                List:[],
                                                echoNumber:0
                                            },
                                            Right:false,
                                            Left:false,
                                            RightBracket: true,
                                            LeftBracket: false,
                                            ShowVarModal:false,
                                    
                                            SelectedVariableKey:{
                                                VImages:[]
                                            },
                                            CheckAnswer: false,
                                            ShowSolution: false
                            
                                        })                           
                    }}
                       >
                          <h5 style = {{color: 'green', textAlign:'center', fontSize:responsiveFontSize(0.9), margin: responsiveFontSize(0.2)}}>
                          Reload question
                           </h5>
                   </div>
                   
                   : <div/>}
                </div>
            </div>
        )
    }

    NextAction(){
        if(this.props.Object.state.QuestionsAnswers.filter(a => !a.Answered).length )
        {
            this.props.Object.setState({
                CurrentIndex: this.props.Object.state.CurrentIndex + 1
            })

            return
        }

        this.props.Object.setState({
            ShowFinalScores: true
        })
    }

    ClearAction(){
        if(!this.state.CheckAnswer){
            this.setState({
                Answer:{
                    List:[],
                    echoNumber:0
                },
                InputError:""
            })
        }
    }

    CheckAnswerAction(){
        if(!this.state.CheckAnswer){

            if(!this.VerifyAnswer()){
                return
            }
            
            let Current_Answer = this.state.Answer.List.reduce((b,a) => b += a.char, '')

            let Answers = this.props.Question.Answers
            .sort((a,b) => a.Id > b.Id ? 1 : -1)
            .map((a, i) => {

                let Correct = false

                if(this.props.Question.IsEnergyBalance){
                    //Get Index of =
                    let CAnswer_Equal_Index = Current_Answer.indexOf('=')
                    let CAnswer_Before = Current_Answer.substring(0, CAnswer_Equal_Index)
                    let CAnswer_After = Current_Answer.substring(CAnswer_Equal_Index + 1, Current_Answer.length)

                    let KAnswer = a.AnswerElements.reduce((b,a) => b += a.IsInteger ? a.TextPresentation : a.Value, '')
                    let KAnswer_Equal_Index = KAnswer.indexOf('=')
                    let KAnswer_Before = KAnswer.substring(0, KAnswer_Equal_Index)
                    let KAnswer_After = KAnswer.substring(KAnswer_Equal_Index + 1, KAnswer.length)
                    
                    let CEquivalent_Answer = CAnswer_Before + "-(" + CAnswer_After + ")"
                    let KEquivalent_Answer = KAnswer_Before + "-(" + KAnswer_After  + ")"
                    
                    Correct = (SafeSimplify("(" + KEquivalent_Answer + ")" +  "-" + "(" +CEquivalent_Answer+ ")" )) == '0'


                    if(!Correct){
                        Correct = (SafeSimplify("(" + KEquivalent_Answer + ")" +  "+" + "(" +CEquivalent_Answer+ ")" )) == '0'
                    }
                }
                else{
                    Correct = (SafeSimplify("(" + a.AnswerElements.reduce((b,a) => b += a.IsInteger ? a.TextPresentation : a.Value, '') + ")" +  "-" + "(" +Current_Answer+ ")" )) == '0'
                }

                return({
                    Correct: Correct, 
                    Index: i
                })
            })

            let Correct = false

            for(let a of Answers){
                Correct = Correct || a.Correct
            }
            
            this.setState({
                CheckAnswer: true,
                AnswersStatusIndexes: Answers.filter(a => a.Correct).map((a) => a.Index), 
                AnswerStatus: Correct,
                InputError: ""
            })

            if(this.props.Object) {
                let QuestionsAnswers = this.props.Object.state.QuestionsAnswers
                let QuestionsAnswersFull = this.props.Object.state.QuestionsAnswersFull

                QuestionsAnswers[this.props.Object.state.CurrentIndex] = {
                    Id: this.props.Question.Id,
                    Answered: true,
                    Score: Correct ? '1/1' : '0/1',
                    Correct:Correct
                }

                QuestionsAnswersFull[this.props.Object.state.CurrentIndex] = this.state.Answer.List

                this.props.Object.setState({
                    QuestionsAnswers:QuestionsAnswers,
                    QuestionsAnswersFull: QuestionsAnswersFull
                })
            }

          

                let VM = ({
                    QuestionId: this.props.Question.Id,
                    Correct: Correct,
                    Score:Correct ? '1/1' : '0/1',
                    Key: this.props.Key,
                    Player: this.props.Player,
                    TotalTime: Math.trunc(0.001 * ((new Date()).getTime() - this.state.StartTime))

                }
                )

                if(!Correct){
                    VM.Latex = this.state.Answer.List.reduce((a,b) => a += ' ' + (b.code == '*' ? '\\cdot': b.code), '')
                }

               this.props.PostPlayStatistic(VM)
        }
    }

    VerifyAnswer(){
        
        if(!this.state.Answer.List.length){
            this.setState({
                InputError:"Answer cannot be empty"
            })

            return
        }

        if(this.state.Answer.echoNumber){
            this.setState({
                InputError:"Please close brackts, " + this.state.Answer.echoNumber + " left to close"
            }) 

            return false
        }

        if(['*','-','+','/', '='].includes(this.state.Answer.List.slice(-1)[0].code)){
            this.setState({
                InputError:"Last charachter cannot be an operand"
            })

            return false
        }

        if(this.props.Question.IsEnergyBalance){
            let AnswerReduced = this.state.Answer.List.reduce((b,a) => b += a.char, '')


            let Equal_Count = 0
            for(let c of AnswerReduced){
                if(c == '='){
                    Equal_Count = Equal_Count + 1
                }
            }

            if(Equal_Count != 1){
                this.setState({
                    InputError:"You should add one 'Equal =' operand"
                })

                return  false
            }

        }

        return true
    }


    AnswerStatusSolutionSection(ShowSolutions){
        return(
            <div>
                <hr/>
                <div style = {{flexDirection:'row', display:'flex', alignContent:'center', alignItems:'center', 
                width: '100%'
                }}
                >
                    <h6 
                    className={!this.state.AnswerStatus ? 'text-danger': 'text-success'}
                    style = {{
                        fontSize: responsiveFontSize(1),
                        textAlign:'center',
                        width:'100%'
                    }}>
                        Your answer is<strong> {!this.state.AnswerStatus ? ' NOT ' : ' '}correct</strong> 
                    
                    </h6>
                </div>
                
                <div className="border">
                <h6
                  className="text-primary"
                  style = {{fontSize: responsiveFontSize(0.9), marginBottom: responsiveHeight(1), marginLeft: responsiveHeight(1)}}
                  >Alternative answers</h6>  
                {(ShowSolutions ? this.props.Question.Answers : []).sort((a,b) => a.Id > b.Id ? 1 : -1).map((a, i ) => (
                    <div key = {i} style = {{marginLeft: responsiveHeight(1)}}>
                        <div style = {{flexDirection:'row', display:'flex', alignItems:'center', alignContent:'center'}}
                        >
                        <div 
                        style = {{width:'2%', marginRight:'1%'}}>
                            <h6 
                            className={"text-muted"}
                            style = {{fontSize: responsiveFontSize(1), textAlign:'left'}}>
                                    {(i + 1)} 
                                    
                            </h6>
                        </div>
                        <div
                        >
                            <RenderLatexAnswer
                            magnifier = {'large'}
                            answer = {a} />
                             {this.state.AnswersStatusIndexes.includes(i) ?
                             <i 
                             className="text-success"
                             style={{fontSize: responsiveFontSize(0.7), marginLeft: responsiveWidth(0.5)}}>
                                (Your answer)
                            </i> : <div/>}
                        </div>
                    </div>
                    <hr/>
                    </div>))}
                </div>
            </div>
            
        )
    }

}

//Constant
//
const QUESTION_SEARCHING_PARAMETER = 'IsKEYBOARDQuestionSearching'

const QUESTION_DATA_PARAMETER = 'KEYBOARDQuestion'

const QUESTION_GET_ERROR_PARAMETER = 'KEYBOARDQuestionGetError'
//
const IVALUES_SEARCHING_PARAMETER = 'IsIIValuesSearching'
const IVALUES_DATA_PARAMETER = 'IIValues'
const IVALUES_GET_ERROR_PARAMETER = 'IIValuesGetError'
//
const QUESTION_STATISTIC_IS_ADDING_PARAMETER = 'QuestionStatisticIsAdding'
const QUESTION_STATISTIC_ERROR_ADD_PARAMETER = 'QuestionStatisticAddError'

function MapStateToProps(state) {
    return {

        IsQuestionSearching: state.Query[QUESTION_SEARCHING_PARAMETER],
        Question: state.Query[QUESTION_DATA_PARAMETER],
        GetQuestionError: state.Query[QUESTION_GET_ERROR_PARAMETER],
        Name: state.Authorization.name,

        Player: state.Authorization.student_key,

        InterpretationValues:state.Query[IVALUES_DATA_PARAMETER],
        IsValuesSearching: state.Query[IVALUES_SEARCHING_PARAMETER],
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        GetInfo: (Id) => {dispatch(GetMultipleListAttempt_ACTION([
            {
                SearchParameter: IVALUES_SEARCHING_PARAMETER,
                DataParameter: IVALUES_DATA_PARAMETER,
                GetErrorParameter: IVALUES_GET_ERROR_PARAMETER,
    
                Path: Routes.GetInterpretationValues,
    
                [IVALUES_SEARCHING_PARAMETER]: true,
                [IVALUES_DATA_PARAMETER]: [],
                [IVALUES_GET_ERROR_PARAMETER]: '',
            },
            {
                SearchParameter: QUESTION_SEARCHING_PARAMETER,
                DataParameter: QUESTION_DATA_PARAMETER,
                GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
                Path: Routes.GetQuestionKeyboard,
    
                Value: Id,
    
                [QUESTION_SEARCHING_PARAMETER]: true,
                
                [QUESTION_DATA_PARAMETER]: {},
        
                [QUESTION_GET_ERROR_PARAMETER]: ''
            }
        ]))},
        GetQuestion: (Id) => {dispatch(GetListAttempt_ACTION({
            SearchParameter: QUESTION_SEARCHING_PARAMETER,
            DataParameter: QUESTION_DATA_PARAMETER,
            GetErrorParameter: QUESTION_GET_ERROR_PARAMETER,
            Path: Routes.GetQuestionKeyboard,

            Value: Id,

            [QUESTION_SEARCHING_PARAMETER]: true,
            
            [QUESTION_DATA_PARAMETER]: {},
    
            [QUESTION_GET_ERROR_PARAMETER]: ''
        }))},
        PostPlayStatistic: (Statistic) => {dispatch(AddObjectAttempt_ACTION({
            AddParameter: QUESTION_STATISTIC_IS_ADDING_PARAMETER,
            AddErrorParameter: QUESTION_STATISTIC_ERROR_ADD_PARAMETER,

            AddPath: Routes.PostStatistic,

            [QUESTION_STATISTIC_IS_ADDING_PARAMETER]: true,
            [QUESTION_STATISTIC_ERROR_ADD_PARAMETER]: '',
            Body:{
                ...Statistic
            }
        }))},
        PostPDFStatistic: (Statistic) => {dispatch(AddFileAttempt_ACTION({
            AddParameter: QUESTION_STATISTIC_IS_ADDING_PARAMETER,
            AddErrorParameter: QUESTION_STATISTIC_ERROR_ADD_PARAMETER,

            AddPath: Routes.AddQuestionPDFStatistic,

            [QUESTION_STATISTIC_IS_ADDING_PARAMETER]: true,
            [QUESTION_STATISTIC_ERROR_ADD_PARAMETER]: '',
            Body:Statistic
        }))},
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(KeyboardQuestionPlayComponent)